import { render, staticRenderFns } from "./ListV2.vue?vue&type=template&id=fb5aa00c"
import script from "./ListV2.vue?vue&type=script&lang=js"
export * from "./ListV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports